export default [
  {
    component: () => import("pages/AudienceFileList.vue"),
    meta: {
      title: "Audience Files",
    },
    name: "audience-files",
    path: "/audience-files/:fileType",
    props: true,
  },
];
